import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/what-we-do", label: "What We Do", testid: "nav-what-we-do" },
  { to: "/our-impact", label: "Our Impact", testid: "nav-our-impact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-white border-b border-black/5"
    >
      <div className="container-saksham flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <div className="h-14 md:h-16 w-52 md:w-64 overflow-hidden flex items-center justify-center">
            <img
              src="/saksham-logo.svg"
              alt="Saksham — Empowering Micropreneurs"
              className="h-[140px] md:h-[170px] w-auto select-none"
              draggable={false}
            />
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={n.testid}
              className={({ isActive }) =>
                `text-sm font-medium link-underline ${isActive ? "text-[#09B792]" : "text-[#0A0A0A]/85 hover:text-[#0A0A0A]"}`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/login"
            data-testid="nav-cta-login"
            className="bg-[#0A0A0A] text-[#FBD223] hover:bg-[#FBD223] hover:text-[#0A0A0A] px-5 py-3 text-sm font-medium transition-colors"
          >
            Log In
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-black/5">
          <div className="container-saksham py-4 flex flex-col gap-3">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`${n.testid}-mobile`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${isActive ? "text-[#09B792]" : "text-[#0A0A0A]"}`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/login"
              data-testid="nav-cta-login-mobile"
              className="mt-2 bg-[#0A0A0A] text-[#FBD223] px-5 py-3 text-sm font-medium text-center"
            >
              Log In
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
